import useLanguageChange from "../../hooks/useLanguageChange";

/* when other participant upload file */
const NotifyParticipant = () => {
    const localisedValues = useLanguageChange();

    return (
        <div className='process-waiting'>
            <div className='process-waiting-in custom-scroll'>
                <div className='process-waiting-box text-center'>
                    <div className='process-waiting-icon'>
                        <span className='for-icon icon-upload'></span>
                    </div>
                    <div className='process-waiting-text'>
                        <div className='process-waiting-text-bar'>{localisedValues?.participant_uploading_file_msg}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotifyParticipant;
